/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AlertNavigator from './alertnavigator/AlertNavigator';
import AlertContainer from './alertcontainer/AlertContainer';
import { alertModel } from './AlertPropTypes';

import styles from './PersistentBanner.scss';

const persistentBannerClassName = styles.persistentBannerClassName.replace(/"/g, '');
const persistentBannerChildClassName = `${persistentBannerClassName}-child`;

export default class PersistentBanner extends Component {
	constructor() {
		super();
		this.state = {
			currentAlert: 0,
		};
	}

	prev = () => {
		let { currentAlert } = this.state;
		this.setState({
			currentAlert: Math.max(--currentAlert, 0),
		});
	};

	onDismiss = () => {
		const callback = this.props.onDismiss;
		if (callback) {
			const potentialPromise = callback(this.state.currentAlert);
			if (potentialPromise && potentialPromise.then) {
				return potentialPromise.then(() => {
					this.prev();
				});
			}

			this.prev();
		}

		return Promise.resolve();
	};

	next = () => {
		let { currentAlert } = this.state;
		const alertsLength = this.props.alerts.length;
		this.setState({
			currentAlert: Math.min(++currentAlert, alertsLength - 1),
		});
	};

	render() {
		const { alerts, onGoToAction } = this.props;
		const { currentAlert } = this.state;

		return (
			alerts &&
			alerts.length > 0 && (
				<div className={persistentBannerClassName}>
					<AlertNavigator
						currentAlert={currentAlert}
						alertsLength={alerts.length}
						className={persistentBannerChildClassName}
						onPrev={this.prev}
						onNext={this.next}
					/>
					<AlertContainer
						alert={alerts[currentAlert]}
						className={persistentBannerChildClassName}
						onDismiss={this.onDismiss}
						onGoToAction={onGoToAction}
					/>
				</div>
			)
		);
	}
}

PersistentBanner.propTypes = {
	/** Alert configuration */
	alerts: PropTypes.arrayOf(alertModel),
	/** Dismiss callback - will be called with the alert index when a alert is dismissed. */
	onDismiss: PropTypes.func,
	/** GoToAction callback - will be called with the alert.action.id when the goto action is clicked and no url is specified with the action. */
	onGoToAction: PropTypes.func,
};
